module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAWCAYAAADwza0nAAAAAXNSR0IArs4c6QAAAHZJREFUOBFjYACC////HwFiELgCxGIgMaIAULEoVBOQGsqaRYnyL0gRFj+PasYXesAAkwDiT0AMAifwqYXLARUyAfE8kA4g+ALEdnBJXAygolFNoMChX0BAbSMtnqCaVIHOBAHiIhekCQSAGhiBOB2I9SEihEkAd9hx9p/FrHcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/arr-right-white.png
// module id = 2021
// module chunks = 153